import { all, put, takeEvery, select } from 'redux-saga/effects'
import * as actionTypes from './action-types'

import { getSnackbars, getSnackbarById } from './selectors'

function* enqueueSnackbarSaga(action) {
  const stateNotifications = yield select(getSnackbars)
  yield put({
    type: actionTypes.SET_SNACKBARS,
    payload: [
      ...stateNotifications,
      {
        key: action.key,
        ...action.notification,
      },
    ],
  })
}

function* closeSnackbarSaga(action) {
  const stateNotifications = yield select(getSnackbars)
  const notification = yield select(getSnackbarById(action.key))

  if (notification.actionOnCancel && notification.actionOnCancel) {
    yield put(notification.actionOnCancel)
  }

  yield put({
    type: actionTypes.SET_SNACKBARS,
    payload: stateNotifications.map(notification =>
      action.dismissAll || notification.key === action.key
        ? { ...notification, dismissed: true }
        : { ...notification },
    ),
  })
}

function* removeSnackbarSaga(action) {
  const stateNotifications = yield select(getSnackbars)
  const notification = yield select(getSnackbarById(action.key))

  if (!notification.dismissed && notification.actionToDo) {
    yield put(notification.actionToDo)
  }

  yield put({
    type: actionTypes.SET_SNACKBARS,
    payload: stateNotifications.filter(
      notification => notification.key !== action.key,
    ),
  })
}

export default function* rootSaga() {
  yield all([
    takeEvery(actionTypes.ENQUEUE_SNACKBAR, enqueueSnackbarSaga),
    takeEvery(actionTypes.CLOSE_SNACKBAR, closeSnackbarSaga),
    takeEvery(actionTypes.REMOVE_SNACKBAR, removeSnackbarSaga),
  ])
}
